import { PhotoCaptions } from "@/types/common";

interface BuildPhotoCaptionsProps {
    marketName: string;
    taskName: string;
    userFullName: string;
    distance: string;
}

export const buildPhotoCaptions = ({
    marketName,
    taskName,
    userFullName,
    distance,
}: BuildPhotoCaptionsProps): PhotoCaptions => {
    return {
        topLines: [taskName, userFullName],
        bottomLines: [marketName, distance],
    };
};
